import { COLORS } from 'constants/index';

export const MuiList = {
  padding: {
    paddingTop: '0',
    paddingBottom: '0',
  },
};

export const MuiListItem = {
  root: {
    borderRadius: '4px',
    '&:hover': {
      backgroundColor: COLORS.BLACK_08,
    },
  },
  gutters: {
    paddingLeft: '8px',
    paddingRight: '8px',
  },
};

export const MuiListItemText = {
  primary: {
    fontWeight: 400,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
};

export const MuiListItemIcon = {
  root: {
    color: COLORS.BLACK_6,
    marginRight: '16px',
    minWidth: '24px',
  },
};

export const MuiListItemSecondaryAction = {
  root: {
    color: COLORS.BLACK_6,
    right: '24px',
  },
};
